<template>
  <img v-lazyload :data-src="src" alt="" />
</template>

<script>
import LazyLoadDirective from "@/directives/LazyLoadDirective";

export default {
  name: "LazyImage",
  directives: {
    lazyload: LazyLoadDirective
  },
  props: {
    src: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped></style>
